module.exports = __webpack_public_path__ + "img/FGr_Brückenbau.1685cd78.svg";